<div #reassignConnectionForm class="aside-nav-v2" [ngClass]="{ 'validation-default': true }">
    <div>
        <bx-side-form>
            <h4 formHeading class="modal-title">Reassign Connection Request</h4>

            <ng-container formBody>
                <section class="form-section" style="height: 500px">
                    <h4>Ressign Connection To</h4>
                    <label
                        [ngClass]="{
                            'has-error': hasSelectError,
                            'has-focus': selectTenantFocused,
                            'bxinput__label-hover': selectTenantHover,
                        }">
                        <span>Select from the list of available locations</span>
                    </label>
                    <ng-select
                        class="light"
                        name="selectTenant"
                        labelForId="selectTenant"
                        bindLabel="name"
                        [items]="reassignTenants"
                        [clearable]="false"
                        [searchable]="true"
                        [(ngModel)]="selectedTenant"
                        (change)="updateTenant($event)"
                        (focus)="selectTenantFocused = true"
                        (blur)="selectTenantFocused = false"
                        (mouseover)="selectTenantHover = true"
                        (mouseout)="selectTenantHover = false"
                        #selectTenant="ngModel"
                        #selectTenantControl>
                    </ng-select>
                </section>

                <div class="modal-validation modal-validation-error" *ngIf="formStatus === formStatusEnum.Error">
                    <div class="controls">
                        <div class="controls-right"><i class="icon-alert icon-ic-alert-s1"></i>&nbsp;&nbsp;{{ formErrorMessage }}</div>
                    </div>
                </div>
            </ng-container>

            <ng-container button-grp>
                <button class="btn-bx-secondary-stroked" type="button" (click)="cancel()">Cancel</button>
                <button
                    [disabled]="formStatus === formStatusEnum.Saving"
                    class="btn-bx-primary ml-2"
                    (click)="reassignConnection()"
                    type="submit">
                    Reassign
                </button>
            </ng-container>
        </bx-side-form>
    </div>
</div>
